import { action, computed, observable } from 'mobx'
import { UserNotificationDTO, UserNotificationStatus } from 'models'
import { GENERAL_STORE } from 'store/GeneralStore'
import { RootStore } from 'store/RootStore'
import { Api, getSortingResult, SortDirection } from 'utilities'

export const NOTIFICATIONS_STORE = 'NOTIFICATIONS_STORE'

export class NotificationsStore {
  private rootStore: RootStore

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore
  }

  @observable
  private userNotificationsMap: Map<number, UserNotificationDTO> = new Map()

  @action
  private setNotificationsMap = (notificationsMap: Map<number, UserNotificationDTO>): void => {
    this.userNotificationsMap = notificationsMap
  }

  @action
  private updateUserNotification = (notification: UserNotificationDTO): void => {
    this.userNotificationsMap.set(notification.id, notification)
  }

  private handleLoadedNotifications = (notifications: UserNotificationDTO[]): void => {
    // console.log('notifications', notifications)
    const notificationsIterable = notifications.map(notification => ([notification.id, notification])) as any
    const notificationsMap = new Map<number, UserNotificationDTO>(notificationsIterable)
    this.setNotificationsMap(notificationsMap)
  }

  public getNotifications = async () => {
    Api
      .get<UserNotificationDTO[]>('/userNotifications/all', 'actionHistoryApi')
      .then(this.handleLoadedNotifications)
      .catch(this.rootStore[GENERAL_STORE].handleApiError)
  }

  private getNotificationById = (id: number): UserNotificationDTO => {
    return this.userNotificationsMap.get(id)
  }

  public markNotificationSeen = (id: number): void => {
    const notification = this.getNotificationById(id)
    Api
      .post<UserNotificationDTO[]>('/userNotifications/updateAll', [notification], 'actionHistoryApi')
      .then(([updatedNotification]) => this.updateUserNotification(updatedNotification))
      .catch(this.rootStore[GENERAL_STORE].handleApiError)
  }

  @computed
  public get userNotificationsList (): UserNotificationDTO[] {
    const notificationsArr = Array.from(this.userNotificationsMap.values())
    notificationsArr.sort((a, b) => {
      return getSortingResult(a.createdDate, b.createdDate, SortDirection.ASC)
    })
    return notificationsArr
  }

  @computed
  public get newNotificationsCount (): number {
    return this.userNotificationsList.reduce((sum, notification) => {
      return notification.notificationStatus === UserNotificationStatus.NEW
        ? sum + 1
        : sum
    }, 0)
  }
}
